<template>
  <div class="add-song">
    <button v-if="!showModel" @click="showModel = true">Add Songs</button>
    <form @submit.prevent="handleSubmit" v-if="showModel">
      <h3>Add New Song</h3>
      <input type="text" required v-model="title" placeholder="Title" />
      <input type="text" required v-model="artist" placeholder="Artist" />
      <input type="file" accept="audio/mp3" @change="handleFileChange" />
      <button v-if="!isPending">Add</button>
      <div v-else class="spinners">
        <loading />
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import useDocument from "@/composable/useDocument";
import useStorage from "@/composable/useStorage";
import loading from "@/components/loading.vue";

export default {
  components: {
    loading,
  },
  props: ["playlist"],
  setup(props) {
    const { updateDoc } = useDocument("playlist", props.playlist.id);

    const { uploadImage, url, filePath, isPending } = useStorage();

    const title = ref("");
    const artist = ref("");
    const music = ref(null);
    const showModel = ref(false);
    const handleSubmit = async () => {
      isPending.value = true;

      await uploadImage(music.value);

      console.log(url);
      const newSong = {
        title: title.value,
        artist: artist.value,
        id: Math.floor(Math.random() * 1000000),
        music: url.value,
        filePath: filePath.value,
      };
      console.log(newSong);

      await updateDoc({ songs: [...props.playlist.songs, newSong] });
      title.value = "";
      artist.value = "";
      music.value = null;
      showModel.value = false;
    };
    isPending.value = false;

    const handleFileChange = (e) => {
      const selected = e.target.files[0];
      console.log(selected.name);
      console.log(selected.type);
      if (selected) {
        music.value = selected;
      } else {
        music.value = null;
      }
    };
    return {
      handleSubmit,
      title,
      artist,
      showModel,
      music,
      handleFileChange,
      isPending,
    };
  },
};
</script>

<style scoped>
.add-song {
  text-align: center;
  margin: 40px 0px 10px 0px;
}
form {
  max-width: 100%;
  text-align: left;
}
</style>